import React, { useCallback } from 'react';
import {
  IconButton,
  Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import ChoicesRow from './row';

function ChoicesTable({ value, onChange, ctype }) {
  const onRowChange = useCallback(
    (e, rowIndex, v) => onChange(e, value.map((vv, i) => (i === rowIndex ? v : vv))),
    [onChange, value],
  );
  const onRowDelete = useCallback(
    (e, rowIndex) => onChange(e, value.filter((vv, i) => i !== rowIndex)),
    [onChange, value],
  );
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              Значення
            </TableCell>
            <TableCell>
              Представлення
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {value.map(([v, label], rowIndex) => (
            <ChoicesRow
              key={v}
              value={v}
              label={label}
              rowIndex={rowIndex}
              onChange={onRowChange}
              onDelete={onRowDelete}
              canDelete={value.length > 1}
              ctype={ctype}
            />
          ))}
        </TableBody>
        <TableFooter>
          <IconButton
            onClick={(e) => onChange(e, [...value, ['', 'Нове значення']])}
            color="success"
          >
            <FontAwesomeIcon icon={faAdd} size="xs" />
          </IconButton>
        </TableFooter>
      </Table>
    </TableContainer>

  );
}

ChoicesTable.propTypes = {
  value: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string, PropTypes.number, PropTypes.bool,
  ]))).isRequired,
  ctype: PropTypes.oneOf(['String', 'Date', 'Boolean', 'Integer', 'Decimal']).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ChoicesTable;
